<template>
  <section
    class="page__section"
    :style="componentStyle"
  >
    <div class="container">
      <app-content
        class="editor__page"
        :content="translate(text)"
      />

      <dl
        class="questions"
        v-if="questions.length"
      >
        <div
          class="questions__li"
          :style="{ 'border-color': componentStyle.color }"
          v-for="(question, index) in questions"
          :key="`faq_question_${index}`"
        >
          <dt v-if="translate(question.text)">
            <button
              class="bold"
              :aria-expanded="question.is_opened"
              :aria-controls="`faq_${index}_desc${uid}`"
              @click.prevent="question.is_opened = !question.is_opened"
            >
              <fa-icon
                class="questions__icon"
                size="xs"
                :icon="['fal', 'chevron-right']"
                :style="{ 'color': componentStyle.color }"
              />

              {{ translate(question.title) }}
            </button>
          </dt>

          <h3
            class="bold"
            v-else
          >
            {{ translate(question.title) }}
          </h3>

          <app-content
            tag="dd"
            class="questions__text"
            :id="`faq_${index}_desc${uid}`"
            :content="translate(question.text)"
            v-show="question.is_opened"
          />
        </div>
      </dl>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useStyle } from '@/composables/app/useStyle'
import { guid } from '@/utils/utils'

import AppContent from '&/atoms/AppContent'

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()
const { componentStyle } = useStyle(section.style)

const { text, questions = [] } = section.attributes
const uid = guid(1)
</script>

<style lang="scss" scoped>
.questions {
  display: flex;
  flex-direction: column;

  &__li {
    padding: 12px;

    &:not(:last-child) {
      border-bottom: 1px solid;
      border-color: $dw;
    }
  }

  &__text {
    margin-top: 6px;
    margin-left: 20px;
  }

  &__icon {
    transition: all .3s;
    margin-right: 12px;
    color: $color--primary;

    &--opened {
      transform: rotate(90deg);
    }
  }
}
</style>
